<app-navigation></app-navigation>

<div class="orange-zone">&nbsp;</div>

<footer>
  @if (translate.currentLang != 'fr') {
    <div>
      <a href="https://www.inkas.ch/inkasso/inkassobuero-schweiz" target="_blank">{{'FooterData.Service'  | translate}}</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <a href="https://www.mediserv.ch/ueber-mediserv/mediserv-ag" target="_blank">{{'FooterData.About'  | translate}}</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <a href="https://www.mediserv.ch/unternehmen/impressum" target="_blank">{{'FooterData.Impressum'  | translate}}</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <a href="https://www.mediserv.ch/unternehmen/datenschutzhinweis" target="_blank">{{'FooterData.DataProtectionNotice'  | translate}}</a>
    </div>
  }

  @if (translate.currentLang == 'fr') {
    <div>
      <a href="https://www.inkas.ch/fr/inkasso/inkassobuero-schweiz" target="_blank">{{'FooterData.Service'  | translate}}</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <a href="https://www.mediserv.ch/fr/a-propos-de/mediserv-sa" target="_blank">{{'FooterData.About'  | translate}}</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <a href="https://www.mediserv.ch/fr/entreprise/mentions-legales" target="_blank">{{'FooterData.Impressum'  | translate}}</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <a href="https://www.mediserv.ch/fr/entreprise/protection-des-donnees" target="_blank">{{'FooterData.DataProtectionNotice'  | translate}}</a>
    </div>
  }
</footer>
